import { canInvokeKakaoShare } from "./giftShare.mjs";

type ShareKakaoArgs = {
  title: string;
  description: string;
  imageUrl: string;
  shareUrl: string;
  androidExecutionParams?: string;
  iosExecutionParams?: string;
};

export function shareKakao({
  title,
  description,
  imageUrl,
  shareUrl,
  androidExecutionParams,
  iosExecutionParams,
}: ShareKakaoArgs): boolean {
  const Kakao = (window as any).Kakao;

  if (!canInvokeKakaoShare(window)) {
    return false;
  }

  const link: any = {
    webUrl: shareUrl,
    mobileWebUrl: shareUrl,
  };

  if (androidExecutionParams) link.androidExecutionParams = androidExecutionParams;
  if (iosExecutionParams) link.iosExecutionParams = iosExecutionParams;

  try {
    Kakao.Share.sendDefault({
      objectType: "feed",
      content: {
        title,
        description,
        imageUrl,
        link,
      },
      buttons: [
        {
          title: "바로가기",
          link,
        },
      ],
    });
    return true;
  } catch (error) {
    console.error("Kakao share failed", error);
    return false;
  }
}

export const REST_API_KEY = (window.AMZ_ENV?.VITE_KAKAO_REST_API_KEY ?? "") as string;
export const REDIRECT_URI = (window.AMZ_ENV?.VITE_KAKAO_REDIRECT_URI ?? "") as string;
export const KAKAO_JS_KEY = (window.AMZ_ENV?.VITE_KAKAO_JAVASCRIPT_KEY ?? "") as string;
// 결정 258: 로그인 동의 화면에 띄울 매장 카카오톡 채널(공개 ID, 예: _xkWUZX)
export const KAKAO_CHANNEL_PUBLIC_ID = (window.AMZ_ENV?.VITE_KAKAO_CHANNEL_PUBLIC_ID ?? "") as string;
